<style>
th.sortable {
  cursor: pointer;
}

th.table-header.sortable.active {
  background: #ffffff !important;
}

[type='checkbox'] + label {
  pointer-events: auto;
}
.loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
.card {
  height: unset !important;
}
</style>

<template lang="pug">
.main-content-padded.main-content-nopad-small
  .row
    .col.s12
      .bcrumb
        a(href='#', @click='resetReseller') Reseller
        a(v-if='reseller && reseller.new') New
        a(v-if='reseller && !reseller.new') {{ reseller.account.firstName }} {{ reseller.account.lastName }}
      Appreseller(
        v-if='reseller',
        :reseller='reseller',
        @updated='onresellerUpdated',
        @created='onresellerCreated'
      )
      div(v-else)
        .row
          .col.s12
            ul.horizontal
              li Quick Filters:
              li(v-for='status in availableStatus')
                label(:for='status')
                  input(
                    :id='status',
                    type='checkbox',
                    :value='status',
                    @change='updateStatusFilter',
                    :checked='selectedStatus.indexOf(status) > -1'
                  )
                  span {{ status }}
            .row
              .col.s12.mt-5
                v-app
                  v-card
                    v-card-title
                      v-spacer
                      v-text-field.sampleclass(
                        v-model='search',
                        append-icon='search',
                        label='Search',
                        single-line='',
                        hide-details=''
                      )
                    v-data-table(
                      :headers='headers',
                      :items='filterbystatus',
                      :pagination.sync='pagination',
                      :loading='isLoading',
                      :search='search',
                      prev-icon='arrow_left',
                      next-icon='arrow_right',
                      sort-icon='arrow_drop_up'
                    )
                      v-progress-linear(
                        v-slot='progress',
                        color='blue',
                        indeterminate
                      )
                      template(v-slot:items='props')
                        td
                          a(@click='showresellerDetails(props.item)', href='#') {{ props.item.account.firstName }} {{ props.item.account.lastName }}
                        td.text-xs-left {{ props.item.account.email }}
                        td.text-xs-left {{ props.item.status }}
                        td.text-xs-left
                          .switch
                            label
                              input(
                                :id='status',
                                type='checkbox',
                                :value='props.item.status',
                                :checked='props.item.status === "approved"',
                                @change='toggleStatus(props.item, props.item.accountId, props.item.account.firstName, props.item.account.lastName, props.item.account.email, props.item.status)'
                              )
                              span.lever

                //- table.highlight
                //-   thead
                //-     tr
                //-       th.table-header.sortable(@click='setSortingField("name")', :class='{active: sortField === "name"}', :style='{width: "30%"}')
                //-         | Name
                //-         i.material-icons.right(v-if='sortField === "name" && !toggleSort') arrow_drop_down
                //-         i.material-icons.right(v-if='sortField === "name" && toggleSort') arrow_drop_up
                //-       th.table-header.sortable(@click='setSortingField("email")', :class='{active: sortField === "email"}', :style='{width: "40%"}')
                //-         | Email
                //-         i.material-icons.right(v-if='sortField === "email" && !toggleSort') arrow_drop_down
                //-         i.material-icons.right(v-if='sortField === "email" && toggleSort') arrow_drop_up
                //-       th.table-header.sortable(@click='setSortingField("status")', :class='{active: sortField === "status"}', :style='{width: "20%"}')
                //-         | Status
                //-         i.material-icons.right(v-if='sortField === "status" && !toggleSort') arrow_drop_down
                //-         i.material-icons.right(v-if='sortField === "status" && toggleSort') arrow_drop_up
                //-       th.table-header.sortable(@click='setSortingField("action")', :class='{active: sortField === "action"}', :style='{width: "10%"}')
                //-         | Action
                //-         i.material-icons.right(v-if='sortField === "action" && !toggleSort') arrow_drop_down
                //-         i.material-icons.right(v-if='sortField === "action" && toggleSort') arrow_drop_up
                //-   tbody
                //-     tr(v-for='(reseller, index) in filterbystatus')
                //-       td
                //-         a(@click='showresellerDetails(index)', href='#') {{reseller.account.firstName}}  {{reseller.account.lastName}}
                //-       td {{reseller.account.email}}
                //-       td {{reseller.status}}
                //-       td
                //-         // a.btn.indigo.tooltipped(@click='approve(index, reseller.accountId, reseller.account.firstName, reseller.account.lastName, reseller.account.email)',
                //-         // v-if='reseller.status === "application" || reseller.status === "disabled" ', data-position='bottom', :data-tooltip='reseller.status') Approve
                //-         //   i.material-icons.right check
                //-         // a.btn.red.tooltipped(@click='disable(index, reseller.accountId)', v-if='reseller.status === "approved"', data-position='bottom', :data-tooltip='reseller.status') Disable
                //-         //   i.material-icons.right visibility_off
                //-         .switch
                //-           label
                //-             input(:id='status', type='checkbox', :value='reseller.status', :checked='reseller.status === "approved"', @change='toggleStatus(index, reseller.accountId, reseller.account.firstName, reseller.account.lastName, reseller.account.email, reseller.status)')
                //-             span.lever
                //-     p.title.medium.grey-text.center-align(v-if='!filterbystatus.length') Nothing to Show
                  //- div.preloader-wrapper.big.active.loader(v-if='!filterbystatus.length')
                  //-   div.spinner-layer.spinner-green-only
                  //-     div.circle-clipper.left
                  //-       div.circle
                  //-     div.gap-patch
                  //-       div.circle
                  //-     div.circle-clipper.right
                  //-       div.circle
</template>
<script>
import Appreseller from '@/components/app-reseller'
import axios from 'axios'

export default {
  meta: {
    title: 'Resellers',
  },
  data() {
    return {
      resellerRefreshInterval: null,
      resellers: [],
      stat: '',
      sortField: 'status',
      toggleSort: false,
      showreseller: false,
      reseller: null,
      resellerIndex: null,
      availableStatus: ['approved', 'application', 'disabled'],
      status: '',
      headers: [
        { text: 'Name', value: 'account.completeName', width: '30%' },
        { text: 'Email', value: 'account.email', width: '30%' },
        { text: 'Status', value: 'status', width: '20%' },
        {
          text: 'Action',
          value: 'name',
          width: '10%',
          align: 'center',
          sortable: false,
        },
      ],
      search: '',
      pagination: {
        rowsPerPage: 10,
        totalItems: null,
        // descending: true,
        // sortBy: 'createdAt',
      },
      isLoading: false,
      totalItems: 0,
    }
  },
  mounted() {
    this.getresellers().then((data) => {
      this.resellers = data.items
      this.pagination.totalItems = data.total
    })
  },
  watch: {
    '$route.query'() {
      // this.getresellers();
    },
  },
  updated() {
    this.$M.Tooltip.init(document.querySelectorAll('.tooltipped'))
  },
  computed: {
    sortedresellers() {
      // let resellers = this.resellers.map((item) => {
      //   item.account.completeName = `${item.account.firstName} ${item.account.lastName}`
      //   return item
      // })
      // return this.resellers.sort(this.sortFunction)
      return this.resellers
        .map((item) => {
          item.account.completeName = `${item.account.firstName} ${item.account.lastName}`
          return item
        })
        .sort(this.sortFunction)
    },
    selectedStatus() {
      return !this.$route.query.status
        ? []
        : typeof this.$route.query.status === 'string'
        ? [this.$route.query.status]
        : this.$route.query.status
    },
    filterbystatus() {
      if (this.stat === '') {
        let sorted = this.sortedresellers
        return sorted
      } else {
        return this.resellers.filter((resellerlst) => {
          return (
            !this.stat ||
            resellerlst.status.toLowerCase().indexOf(this.stat.toLowerCase()) >
              -1
          )
        })
      }
    },
    isApplicant() {
      return this.resellers.status === 'application'
    },
    isApproved() {
      return this.resellers.status === 'approved'
    },
    isDisabled() {
      return this.resellers.status === 'disabled'
    },
  },
  created() {
    this.resellerRefreshInterval
  },
  beforeDestroy() {
    clearInterval(this.resellerRefreshInterval)
  },
  methods: {
    updateStatusFilter(e) {
      const selectedStatus = this.selectedStatus.splice()
      const index = this.selectedStatus.indexOf(e.target.value)
      if (e.target.checked && index === -1) {
        selectedStatus.push(e.target.value)
      } else if (!e.target.checked && index !== -1) {
        selectedStatus.splice(index, 1)
      }
      let query = {
        ...this.$route.query,
        status: selectedStatus,
      }
      this.$router.push({
        name: 'reseller',
        query: query,
      })
      if (selectedStatus.length) this.stat = e.target.value
      else this.stat = ''
    },
    resetReseller() {
      this.reseller = null
      this.resellerIndex = null
    },
    onresellerCreated(reseller) {
      this.reseller = reseller
      this.resellers.push(reseller)
    },
    onresellerUpdated(reseller) {
      if (this.reseller.id === reseller.id) {
        this.reseller = reseller
        this.resellers.splice(this.resellerIndex, 1, reseller)
      }
    },
    newreseller() {
      this.reseller = {
        new: true,
      }
    },
    showresellerDetails(index) {
      // this.reseller = this.filterbystatus[index];
      this.reseller = index
      this.resellerIndex = index
    },
    // sortFunction (orderA, orderB) {
    //   const fieldA = orderA[this.sortField]
    //   const fieldB = orderB[this.sortField]
    //   let result = fieldA === fieldB ? 0 : !fieldA && !!fieldB ? 1 : !!fieldA && !fieldB ? -1 : fieldA.toLowerCase() < fieldB.toLowerCase() ? -1 : fieldA.toLowerCase() === fieldB.toLowerCase() ? 0 : 1
    //   return this.toggleSort ? result * -1 : result
    // },
    sortFunction(orderA, orderB) {
      let fieldA = '',
        fieldB = ''
      if (this.sortField === 'name') {
        fieldA = orderA.account['firstName'] + ' ' + orderA.account['lastName']
        fieldB = orderB.account['firstName'] + ' ' + orderB.account['lastName']
      } else if (this.sortField === 'status') {
        fieldA = orderA[this.sortField]
        fieldB = orderB[this.sortField]
      } else if (this.sortField === 'action') {
        fieldA = orderA['status'] === 'approved' ? 'a' : 'b'
        fieldB = orderB['status'] === 'approved' ? 'a' : 'b'
      } else {
        fieldA = orderA.account[this.sortField]
        fieldB = orderB.account[this.sortField]
      }

      let result =
        fieldA === fieldB
          ? 0
          : !fieldA && !!fieldB
          ? 1
          : !!fieldA && !fieldB
          ? -1
          : fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1
      return this.toggleSort ? result * -1 : result
    },
    setSortingField(sortField) {
      if (this.sortField === sortField) {
        this.toggleSort = !this.toggleSort
      }
      this.sortField = sortField
    },
    getresellers() {
      this.isLoading = true
      // this.resellerRefreshInterval = setInterval(() => {
      // this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
      //   axios
      //     .get(`${this.$config.API_URL}/admin/resellers/list`, {
      //       headers: {
      //         Authorization: `Bearer ${accessToken}`,
      //       },
      //     })
      //     .then((result) => {
      //       this.resellers = result.data
      //       this.isLoading = false
      //     })
      // })
      // }, 3000)
      return new Promise((resolve, reject) => {
        this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
          axios
            .get(`${this.$config.API_URL}/admin/resellers/list`, {
              params: {
                deep: true,
                // ...this.$route.query
              },
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            })
            .then((result) => {
              const items = result.data
              const total = items.length

              setTimeout(() => {
                this.isLoading = false
                resolve({
                  items,
                  total,
                })
              }, 300)
            })
        })
      })
    },
    approve(item, id, fname, lname, email) {
      this.resellerData = {
        id: id,
        firstname: fname,
        lastname: lname,
        email: email,
      }
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .post(
            `${this.$config.API_URL}/admin/approved-reseller/`,
            this.resellerData,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            item.status = 'approved'
          })
      })
    },
    disable(item, rAccountID) {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .get(`${this.$config.API_URL}/admin/disable-reseller/${rAccountID}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            // this.resellers[rowID].status = "disabled";
            item.status = 'disabled'
          })
      })
    },
    toggleStatus(item, id, fname, lname, email, status) {
      if (status === 'approved') {
        this.disable(item, id)
      } else {
        this.approve(item, id, fname, lname, email)
      }
    },
  },
  components: {
    Appreseller,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-reseller.vue